import { fromFetch } from 'rxjs/fetch';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import {
  PreferencesAccount,
  preferencesAccountSchema,
} from '../schemas/preferences-account.schema';

/**
 * Update the preferences for the account
 * @param preferences The preferences for the account
 * @returns Data object containing the newly updated Preferences
 */
export function putPreferencesAccount(
  this: unknown,
  preferences: PreferencesAccount
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(fleetEnvironment.resolve(this).preferencesAccountUrl, {
        method: 'PUT',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
        body: JSON.stringify(preferences),
      })
    )
  ).pipe(selectData(preferencesAccountSchema));
}
